import { render, staticRenderFns } from "./category-tag.vue?vue&type=template&id=d8f9868c&"
import script from "./category-tag.vue?vue&type=script&lang=js&"
export * from "./category-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports